import { render, staticRenderFns } from "./AvailableDirectories.vue?vue&type=template&id=0196c35b&scoped=true&"
import script from "./AvailableDirectories.vue?vue&type=script&lang=js&"
export * from "./AvailableDirectories.vue?vue&type=script&lang=js&"
import style0 from "./AvailableDirectories.vue?vue&type=style&index=0&id=0196c35b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0196c35b",
  null
  
)

export default component.exports